<!--Extended Table starts-->
<div class="row">
  <div class="col-12">
    <div class="content-header">Extended Tables</div>
  </div>
</div>
<section id="extended">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Action Buttons</h4>
        </div>
        <div class="card-content">
          <div class="card-body table-responsive">
            <table class="table text-center m-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th></th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Gender</th>
                  <th>Email</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>
                    <div class="checkbox">
                      <input type="checkbox" id="item1">
                      <label for="item1"></label>
                    </div>
                  </td>
                  <td>Kelly</td>
                  <td>Carter</td>
                  <td>Female</td>
                  <td>kellycarter@mail.com</td>
                  <td class="text-truncate">
                    <a href="javascript:;" class="info p-0">
                      <i class="ft-user font-medium-3 mr-2"></i>
                    </a>
                    <a href="javascript:;" class="success p-0">
                      <i class="ft-edit-2 font-medium-3 mr-2"></i>
                    </a>
                    <a href="javascript:;" class="danger p-0">
                      <i class="ft-x font-medium-3"></i>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>
                    <div class="checkbox">
                      <input type="checkbox" id="item2">
                      <label for="item2"></label>
                    </div>
                  </td>
                  <td>Peter</td>
                  <td>Parker</td>
                  <td>Male</td>
                  <td>peterparker@mail.com</td>
                  <td class="text-truncate">
                    <a href="javascript:;" class="info p-0">
                      <i class="ft-user font-medium-3 mr-2"></i>
                    </a>
                    <a href="javascript:;" class="success p-0">
                      <i class="ft-edit-2 font-medium-3 mr-2"></i>
                    </a>
                    <a href="javascript:;" class="danger p-0">
                      <i class="ft-x font-medium-3"></i>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>
                    <div class="checkbox">
                      <input type="checkbox" id="item3">
                      <label for="item3"></label>
                    </div>
                  </td>
                  <td>William</td>
                  <td>Rambo</td>
                  <td>Male</td>
                  <td>williamrambo@mail.com</td>
                  <td class="text-truncate">
                    <a href="javascript:;" class="info p-0">
                      <i class="ft-user font-medium-3 mr-2"></i>
                    </a>
                    <a href="javascript:;" class="success p-0">
                      <i class="ft-edit-2 font-medium-3 mr-2"></i>
                    </a>
                    <a href="javascript:;" class="danger p-0">
                      <i class="ft-x font-medium-3"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Extended Table Ends-->
<!--Shopping cart starts-->
<section id="shopping-cart">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Shopping Cart</h4>
        </div>
        <div class="card-content">
          <div class="card-body table-responsive">
            <table class="table text-center m-0">
              <thead>
                <tr>
                  <th>Image</th>
                  <th>Product</th>
                  <th>Weight</th>
                  <th>Price</th>
                  <th>Quantity</th>
                  <th>Amount</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><img src="assets/img/elements/01.png" alt="product" style="height: 75px;"></td>
                  <td>Product 1</td>
                  <td>38.9 Ounce</td>
                  <td>$ 9.97</td>
                  <td>
                    <div class="btn-group ml-1">
                      <a class="btn btn-primary px-1 py-1 font-medium-5" href="javascript:void(0)">-</a>
                      <a class="btn btn-primary px-1 py-1" href="javascript:void(0)">2</a>
                      <a class="btn btn-primary px-1 py-1 font-medium-5" href="javascript:void(0)">+</a>
                    </div>
                  </td>
                  <td>$ 19.94</td>
                  <td>
                    <a href="javascript:;" class="danger">
                      <i class="ft-trash font-medium-3"></i>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td><img src="assets/img/elements/07.png" alt="product" style="height: 75px;"></td>
                  <td>Product 2</td>
                  <td>15.9 Ounce</td>
                  <td>$ 6.00</td>
                  <td>
                    <div class="btn-group ml-1">
                      <a class="btn btn-primary px-1 py-1 font-medium-5" href="javascript:void(0)">-</a>
                      <a class="btn btn-primary px-1 py-1" href="javascript:void(0)">2</a>
                      <a class="btn btn-primary px-1 py-1 font-medium-5" href="javascript:void(0)">+</a>
                    </div>
                  </td>
                  <td>$ 12.00</td>
                  <td>
                    <a href="javascript:;" class="danger">
                      <i class="ft-trash font-medium-3"></i>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td><img src="assets/img/elements/11.png" alt="product" style="height: 75px;"></td>
                  <td>Product 3</td>
                  <td>20.9 Ounce</td>
                  <td>$ 15.78</td>
                  <td>
                    <div class="btn-group ml-1">
                      <a class="btn btn-primary px-1 py-1 font-medium-5" href="javascript:void(0)">-</a>
                      <a class="btn btn-primary px-1 py-1" href="javascript:void(0)">1</a>
                      <a class="btn btn-primary px-1 py-1 font-medium-5" href="javascript:void(0)">+</a>
                    </div>
                  </td>
                  <td>$ 15.78</td>
                  <td>
                    <a href="javascript:;" class="danger">
                      <i class="ft-trash font-medium-3"></i>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td><img src="assets/img/elements/14.png" alt="product" style="height: 75px;"></td>
                  <td>Product 4</td>
                  <td>90 Ounce</td>
                  <td>$ 24.51</td>
                  <td>
                    <div class="btn-group ml-1">
                      <a class="btn btn-primary px-1 py-1 font-medium-5" href="javascript:void(0)">-</a>
                      <a class="btn btn-primary px-1 py-1" href="javascript:void(0)">3</a>
                      <a class="btn btn-primary px-1 py-1 font-medium-5" href="javascript:void(0)">+</a>
                    </div>
                  </td>
                  <td>$ 73.53</td>
                  <td>
                    <a href="javascript:;" class="danger">
                      <i class="ft-trash font-medium-3"></i>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><b>Total</b></td>
                  <td><b>$‭ 121.25‬</b></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><button class="btn btn-primary">Continue</button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Shopping cart ends-->
